/**
 * A/B test: hide 1st Kaching carousel item (Socle de recharge) in cart drawer.
 *
 * body attribute (IntelliGems / AB tool):
 *   data-elios-cart-dock-test="true"  → Test A / control — slider item visible
 *   data-elios-cart-dock-test="false" → Test B / variant — 1st slider item hidden
 */
(function () {
  'use strict';

  var BODY_ATTR = 'data-elios-cart-dock-test';
  var HIDDEN_ATTR = 'data-elios-cart-hidden';
  var KACHING_ITEM = '.kaching-cart__carousel-item';
  var KACHING_LIST = '.kaching-cart__carousel-list';

  function shouldHideDock() {
    var value = document.body && document.body.getAttribute(BODY_ATTR);
    return String(value).toLowerCase() === 'false';
  }

  function hideNode(node) {
    if (!node || node.getAttribute(HIDDEN_ATTR) === 'true') return;

    node.setAttribute(HIDDEN_ATTR, 'true');
    node.setAttribute('hidden', '');
    node.style.setProperty('display', 'none', 'important');
    node.setAttribute('aria-hidden', 'true');
  }

  function showNode(node) {
    if (!node || node.getAttribute(HIDDEN_ATTR) !== 'true') return;

    node.removeAttribute(HIDDEN_ATTR);
    node.removeAttribute('hidden');
    node.style.removeProperty('display');
    node.removeAttribute('aria-hidden');
  }

  function applyKachingCarousel() {
    document.querySelectorAll(KACHING_LIST).forEach(function (list) {
      var firstItem = list.querySelector(':scope > ' + KACHING_ITEM);

      if (!firstItem) return;

      if (shouldHideDock()) {
        hideNode(firstItem);
      } else {
        showNode(firstItem);
      }
    });
  }

  function run() {
    applyKachingCarousel();
  }

  function init() {
    run();

    if (document.body) {
      new MutationObserver(run).observe(document.body, {
        attributes: true,
        attributeFilter: [BODY_ATTR],
        childList: true,
        subtree: true
      });
    }

    var delays = [0, 300, 800, 1500, 2500, 4000, 6000, 9000, 12000];
    delays.forEach(function (delay) {
      window.setTimeout(run, delay);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('cart:change', run);
  document.addEventListener('cart:refresh', run);
  document.addEventListener('dialog:after-show', function () {
    window.setTimeout(run, 0);
    window.setTimeout(run, 400);
    window.setTimeout(run, 1200);
  });
})();
